import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoContainerV2Component, DecodeHtmlString } from './video-container-v2.component';
import { AngularSharedUiNmoModule } from '../angular-shared-ui-nmo.module';
import { AngularSharedUtilNmoModule } from '@candyland/angular/shared/util-nmo';

@NgModule({
  declarations: [VideoContainerV2Component, DecodeHtmlString],
  imports: [CommonModule, AngularSharedUiNmoModule, AngularSharedUtilNmoModule],
  exports: [VideoContainerV2Component],
})
export class VideoContainerV2Module {}
